import type { ReactNode } from "react";

/** One answer line: the microphone on the left, the field, the send arrow on the right. */
export function AnswerLine({ mic, field, send }: { mic?: ReactNode; field: ReactNode; send: ReactNode }) {
  return (
    <div className="subtitle-answer">
      {mic}
      {field}
      {send}
    </div>
  );
}
